"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Namespace = void 0;
const helpers_js_1 = require("./helpers.js");
class Namespace {
    loaders;
    constructor(loaders) {
        this.loaders = loaders;
    }
    hasLocale(locale) {
        return this.getLoader(locale) != null;
    }
    getLoader(locale) {
        return this.loaders[locale] || this.loaders[(0, helpers_js_1.extractLanguage)(locale)];
    }
    async load(locale) {
        // The fallback loader will be used in case loader for original locale isn't defined
        const loaderLocale = this.loaders[locale]
            ? locale
            : (0, helpers_js_1.extractLanguage)(locale);
        const loader = this.getLoader(locale);
        if (loader == null) {
            return {};
        }
        if (typeof loader !== 'function') {
            return loader;
        }
        try {
            const messages = (0, helpers_js_1.resolveDefaultExports)(await loader());
            this.loaders[loaderLocale] = messages;
            return messages;
        }
        catch (error) {
            throw new Error(`Cache error: Could not load "${loaderLocale}", Error: "${error instanceof Error ? error.message : ''}"`);
        }
    }
    forEachLoadedLocale(callback) {
        for (const locale of Object.keys(this.loaders)) {
            const messages = this.loaders[locale];
            if (typeof messages !== 'function') {
                callback(locale, messages);
            }
        }
    }
}
exports.Namespace = Namespace;
//# sourceMappingURL=Namespace.js.map